import React, { useRef } from 'react'
import { InformationCircleIcon } from '@heroicons/react/24/outline'
import PortalModal from '../Common/Modal/PortalModal'

const ReagentsModal = ({ reagents, description, mixtureName, showPreview = true, iconColor = 'primary', iconSize = 'md' }) => {
    const tagList = reagents.map(x => x).join(", ")
    const modalRef = useRef(null)

    const handleModal = (e) => {
        e.stopPropagation()
        if (modalRef.current) {
            modalRef.current.showModal()
        } else {
            console.warn('modalRef is not available')
        }
    }

    const getIconColor = () => {
        switch (iconColor) {
            case 'primary':
                return 'text-primary hover:text-primary-focus'
            case 'ghost':
                return 'text-base-content/50 hover:text-primary'
            default:
                return 'text-primary hover:text-primary-focus'
        }
    }
    const getIconSize = () => {
        switch (iconSize) {
            case 'sm':
                return 'w-4 h-4'
            case 'md':
                return 'w-5 h-5'
            case 'lg':
                return 'w-6 h-6'
            default:
                return 'w-5 h-5'
        }
    }

    return (
        <>
            <div onClick={handleModal} className='flex items-center gap-2'>
                {showPreview ? <span className='line-clamp-1 h-full self-center max-w-80 lg:max-w-96 text-ellipsis overflow-hidden cursor-pointer transition-all hover:scale-95 hover:underline-offset-4 hover:underline hover:decoration-base-content'>
                    {(description === "" || description === null) ? tagList : description}
                </span> :
                    <InformationCircleIcon
                        title='Afficher la composition'
                        className={`cursor-pointer transition-colors duration-200 ${getIconSize()} ${getIconColor()}`}
                    />
                }
            </div>
            <PortalModal ref={modalRef} layout={false}>
                <div className='bg-base-100 rounded-lg shadow-xl  w-auto'>
                    {/* Header */}
                    <div className='border-b border-base-300 p-6 pb-4'>
                        <div className='flex items-center gap-3'>
                            <div className='w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center'>
                                <InformationCircleIcon className='w-5 h-5 text-primary' />
                            </div>
                            <div>
                                <h2 className='text-xl font-semibold text-base-content'>Composition: {mixtureName}</h2>
                                <p className='text-sm text-base-content/70'>Réactifs</p>
                            </div>
                        </div>
                    </div>

                    {/* Content */}
                    <div className='p-6 pt-4'>
                        {description && description !== "" ? (
                            // Si description disponible, afficher uniquement la description
                            <div className='space-y-3'>
                                <h3 className='text-sm font-medium text-base-content/80 uppercase tracking-wide'>
                                    Description
                                </h3>
                                <div className='p-4 bg-base-200/30 rounded-lg'>
                                    <p className='text-base-content leading-relaxed'>{description}</p>
                                </div>
                            </div>
                        ) : (
                            // Sinon afficher la liste des réactifs
                            reagents && reagents.length > 0 && (
                                <div className='space-y-2 max-h-[320px] lg:max-h-[680px] overflow-y-auto'>
                                    {reagents.map((reagent, index) => (
                                        <div
                                            key={index}
                                            className='flex items-center gap-3 p-1'
                                        >
                                            <div className='w-2 h-2 bg-primary rounded-full flex-shrink-0'></div>
                                            <span className='text-base-content line-clamp-2'>{reagent}</span>
                                        </div>
                                    ))}
                                </div>
                            )
                        )}


                    </div>

                    {/* Footer */}
                    <div className='border-t border-base-300 p-6 pt-4'>
                        <button
                            className='btn btn-primary w-full'
                            onClick={() => modalRef.current?.hideModal()}
                        >
                            Fermer
                        </button>
                    </div>
                </div>
            </PortalModal>
        </>
    )
}

export default ReagentsModal
